import React from 'react'
import { ExcelReader } from '../components/ExcelFileReader'

export const PageTest = () => {
    return (
        <div>
           <ExcelReader />
        </div>
    )
}